import { useIntl } from 'gatsby-plugin-intl'
import { getWithFallback } from 'masterplan-shared'
import { groupBy, pipe } from 'lodash/fp'

export default (domain: string) =>
  pipe([
    getWithFallback([`${domain}.nodes`, domain]),
    groupBy('node_locale'),
    (data: { [key: string]: string }) => data[useIntl().locale],
  ])
